import React, { useState } from 'react';
import { Download, CheckCircle, AlertCircle, ChevronDown, ChevronUp, Calendar, Mail, Edit2, Send, User } from 'lucide-react';
export function DunderMifflinApplicationView() {
  const [expandedRef, setExpandedRef] = useState<string | null>(null);
  const [expandedGuarantor, setExpandedGuarantor] = useState<string | null>(null);
  const tradeReferences = [{
    id: 'paperplus',
    company: 'PaperPlus Wholesale',
    status: 'pending',
    statusText: 'Pending since March 28, 2026',
    emailsSent: '1 email sent',
    contact: {
      name: 'Todd Packer',
      phone: '(570) 555-0142',
      email: 't.packer@paperplus.com'
    },
    details: null
  }, {
    id: 'millerpaper',
    company: 'Miller Paper Supply',
    status: 'completed',
    statusText: 'Completed on March 27, 2026',
    emailsSent: '1 email sent',
    contact: {
      name: 'Tom Halpert',
      phone: '(215) 555-0188',
      email: 't.halpert@millerpaper.com'
    },
    details: {
      yearsAsCustomer: 12,
      creditLimit: '$75,000',
      currentBalance: '$8,200',
      paymentHabits: 'Prompt / Within Terms',
      recommended: 'Yes',
      responseDate: 'March 27, 2026'
    }
  }, {
    id: 'officemax',
    company: 'OfficeMax Distributors',
    status: 'not-sent',
    statusText: 'Not Sent',
    emailsSent: null,
    contact: {
      name: 'Gabe Lewis',
      phone: '(850) 555-0177',
      email: 'g.lewis@officemaxdist.com',
      address: '221 Commerce Way, Tallahassee FL 32301'
    },
    details: null
  }];
  return <div className="space-y-6" data-id="element-935">
      {/* Application Header */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-936">
        <div className="flex items-center justify-between mb-4" data-id="element-937">
          <div data-id="element-938">
            <div className="flex items-center gap-3 mb-2" data-id="element-939">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-940">
                Credit Application
              </h2>
              <span className="px-3 py-1 bg-green-100 text-green-700 border border-green-300 rounded-full text-sm font-medium flex items-center gap-1" data-id="element-941">
                <span className="text-lg" data-id="element-942">🔍</span>
                Ready for Review
              </span>
            </div>
            <div className="text-sm text-gray-600 space-y-1" data-id="element-943">
              <p data-id="element-944">
                <span className="font-semibold" data-id="element-945">Started On:</span> March 27,
                2026
              </p>
              <p data-id="element-946">
                <span className="font-semibold" data-id="element-947">Submitted On:</span> March 27,
                2026
              </p>
            </div>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-948">
            <Download className="w-4 h-4" data-id="element-949" />
            DOWNLOAD PDF
          </button>
        </div>
      </div>

      {/* Applicant Details */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-950">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-951">
          Applicant Details
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-952">
          <div data-id="element-953">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-954">
              Name
            </label>
            <p className="text-gray-900" data-id="element-955">Pam Beesly</p>
          </div>
          <div data-id="element-956">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-957">
              Company
            </label>
            <p className="text-gray-900" data-id="element-958">Dunder Mifflin Paper Company Inc</p>
          </div>
          <div data-id="element-959">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-960">
              Role
            </label>
            <p className="text-gray-900" data-id="element-961">Office Administrator</p>
          </div>
          <div data-id="element-962">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-963">
              Department
            </label>
            <p className="text-gray-900" data-id="element-964">Administration</p>
          </div>
          <div data-id="element-965">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-966">
              Email
            </label>
            <div className="flex items-center gap-2" data-id="element-967">
              <p className="text-gray-900" data-id="element-968">pam.beesly@dundermifflin.com</p>
              <CheckCircle className="w-4 h-4 text-green-600" data-id="element-969" />
            </div>
          </div>
          <div data-id="element-970">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-971">
              Phone Number
            </label>
            <p className="text-gray-900" data-id="element-972">(570) 555-0126</p>
          </div>
        </div>

        {/* Email Verification */}
        <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg" data-id="element-973">
          <div className="flex items-start gap-3" data-id="element-974">
            <CheckCircle className="w-5 h-5 text-green-600 mt-0.5" data-id="element-975" />
            <div data-id="element-976">
              <div className="font-semibold text-gray-900 mb-1" data-id="element-977">
                Email Verification
              </div>
              <p className="text-sm text-gray-700" data-id="element-978">
                Email verified and matches company domain.
              </p>
            </div>
          </div>
        </div>

        {/* IP Address */}
        <div className="mt-4" data-id="element-979">
          <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-980">
            Location (IP Address)
          </label>
          <div className="flex items-center gap-2" data-id="element-981">
            <p className="text-gray-900" data-id="element-982">Scranton, PA (136.61.36.131)</p>
            <CheckCircle className="w-4 h-4 text-green-600" data-id="element-983" />
          </div>
        </div>

        {/* IP Verification */}
        <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg" data-id="element-984">
          <div className="flex items-start gap-3" data-id="element-985">
            <CheckCircle className="w-5 h-5 text-green-600 mt-0.5" data-id="element-986" />
            <div data-id="element-987">
              <div className="font-semibold text-gray-900 mb-1" data-id="element-988">
                IP Address Verification
              </div>
              <p className="text-sm text-gray-700" data-id="element-989">
                Applicant location matches company headquarters.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Company Information */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-990">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-991">
          Company Information
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-992">
          <div data-id="element-993">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-994">
              Legal Business Name
            </label>
            <p className="text-gray-900" data-id="element-995">Dunder Mifflin Paper Company, Inc.</p>
          </div>
          <div data-id="element-996">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-997">
              DBA
            </label>
            <p className="text-gray-900" data-id="element-998">Dunder Mifflin</p>
          </div>
          <div data-id="element-999">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1000">
              Business Address
            </label>
            <p className="text-gray-900" data-id="element-1001">
              1725 Slough Avenue
              <br data-id="element-1002" />
              Scranton, PA 18505
            </p>
          </div>
          <div data-id="element-1003">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1004">
              Years in Business
            </label>
            <p className="text-gray-900" data-id="element-1005">77 years</p>
          </div>
          <div data-id="element-1006">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1007">
              Tax ID / EIN
            </label>
            <p className="text-gray-900" data-id="element-1008">**-***1865</p>
          </div>
          <div data-id="element-1009">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1010">
              Industry
            </label>
            <p className="text-gray-900" data-id="element-1011">Paper & Office Supplies</p>
          </div>
        </div>
      </div>

      {/* Requested Credit Terms */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1012">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1013">
          Requested Credit Terms
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1014">
          <div data-id="element-1015">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1016">
              Requested Credit Limit
            </label>
            <p className="text-gray-900 text-lg font-semibold" data-id="element-1017">$50,000</p>
          </div>
          <div data-id="element-1018">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1019">
              Payment Terms
            </label>
            <p className="text-gray-900" data-id="element-1020">Net 30</p>
          </div>
          <div data-id="element-1021">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1022">
              Estimated Monthly Volume
            </label>
            <p className="text-gray-900" data-id="element-1023">$15,000 - $20,000</p>
          </div>
          <div data-id="element-1024">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1025">
              Purpose
            </label>
            <p className="text-gray-900" data-id="element-1026">Office supplies and paper products</p>
          </div>
        </div>
      </div>

      {/* Trade References */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1027">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1028">
          Trade References
        </h3>
        <div className="space-y-3" data-id="element-1029">
          {tradeReferences.map(ref => <div key={ref.id} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-1030">
              {/* Collapsed Header */}
              <button onClick={() => setExpandedRef(expandedRef === ref.id ? null : ref.id)} className="w-full p-4 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1031">
                <div className="flex items-center gap-4" data-id="element-1032">
                  <span className="font-semibold text-gray-900" data-id="element-1033">
                    {ref.company}
                  </span>
                  <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-1034">
                    <div className="flex items-center gap-1" data-id="element-1035">
                      <Calendar className="w-4 h-4" data-id="element-1036" />
                      {ref.statusText}
                    </div>
                    {ref.emailsSent && <>
                        <span className="text-gray-300" data-id="element-1037">•</span>
                        <div className="flex items-center gap-1" data-id="element-1038">
                          <Mail className="w-4 h-4" data-id="element-1039" />
                          {ref.emailsSent}
                        </div>
                      </>}
                  </div>
                </div>
                {expandedRef === ref.id ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-1040" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-1041" />}
              </button>

              {/* Expanded Content */}
              {expandedRef === ref.id && <div className="border-t border-gray-200 p-6 bg-gray-50" data-id="element-1042">
                  {/* Reference Information */}
                  <div className="mb-6" data-id="element-1043">
                    <div className="flex items-center gap-2 mb-4" data-id="element-1044">
                      <span className="font-semibold text-gray-900" data-id="element-1045">
                        Reference Information
                      </span>
                      <Edit2 className="w-4 h-4 text-indigo-600 cursor-pointer" data-id="element-1046" />
                    </div>
                    <div className="grid grid-cols-2 gap-6" data-id="element-1047">
                      <div data-id="element-1048">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1049">
                          Company Name
                        </label>
                        <p className="text-gray-900" data-id="element-1050">{ref.company}</p>
                      </div>
                      <div data-id="element-1051">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1052">
                          Contact Name
                        </label>
                        <p className="text-gray-900" data-id="element-1053">{ref.contact.name}</p>
                      </div>
                      <div data-id="element-1054">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1055">
                          Contact Phone Number
                        </label>
                        <p className="text-gray-900" data-id="element-1056">{ref.contact.phone}</p>
                      </div>
                      <div data-id="element-1057">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1058">
                          Contact Work Email
                        </label>
                        <p className="text-gray-900" data-id="element-1059">{ref.contact.email}</p>
                      </div>
                      {ref.contact.address && <div className="col-span-2" data-id="element-1060">
                          <label className="text-sm text-gray-500 mb-1 block" data-id="element-1061">
                            Company Address
                          </label>
                          <p className="text-gray-900" data-id="element-1062">{ref.contact.address}</p>
                        </div>}
                    </div>
                  </div>

                  {/* Status-specific content */}
                  {ref.status === 'pending' && <div data-id="element-1063">
                      <div className="font-semibold text-gray-900 mb-2" data-id="element-1064">
                        Awaiting Response
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-1065">
                        The reference request has been sent 1 times.
                      </p>
                      <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1066">
                        <Send className="w-4 h-4" data-id="element-1067" />
                        SEND REMINDER
                      </button>
                    </div>}

                  {ref.status === 'completed' && ref.details && <div data-id="element-1068">
                      <div className="flex items-center gap-2 mb-4" data-id="element-1069">
                        <div className="font-semibold text-gray-900" data-id="element-1070">
                          Reference Completed
                        </div>
                        <CheckCircle className="w-5 h-5 text-green-600" data-id="element-1071" />
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-1072">
                        Response received on {ref.details.responseDate}
                      </p>
                      <div className="grid grid-cols-2 gap-x-12 gap-y-4 text-sm" data-id="element-1073">
                        <div className="flex justify-between" data-id="element-1074">
                          <span className="text-gray-600" data-id="element-1075">
                            Years as Customer
                          </span>
                          <span className="font-medium text-gray-900" data-id="element-1076">
                            {ref.details.yearsAsCustomer}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-1077">
                          <span className="text-gray-600" data-id="element-1078">Credit Limit</span>
                          <span className="font-medium text-gray-900" data-id="element-1079">
                            {ref.details.creditLimit}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-1080">
                          <span className="text-gray-600" data-id="element-1081">Current Balance</span>
                          <span className="font-medium text-gray-900" data-id="element-1082">
                            {ref.details.currentBalance}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-1083">
                          <span className="text-gray-600" data-id="element-1084">Payment Habits</span>
                          <span className="font-medium text-gray-900" data-id="element-1085">
                            {ref.details.paymentHabits}
                          </span>
                        </div>
                        <div className="flex justify-between col-span-2" data-id="element-1086">
                          <span className="text-gray-600" data-id="element-1087">Recommended</span>
                          <span className="font-medium text-gray-900" data-id="element-1088">
                            {ref.details.recommended}
                          </span>
                        </div>
                      </div>
                    </div>}

                  {ref.status === 'not-sent' && <div data-id="element-1089">
                      <div className="font-semibold text-gray-900 mb-2" data-id="element-1090">
                        Ready to Send
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-1091">
                        This trade reference request has not yet been sent to
                        the contact.
                      </p>
                      <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1092">
                        <Send className="w-4 h-4" data-id="element-1093" />
                        SEND REFERENCE
                      </button>
                    </div>}
                </div>}
            </div>)}
        </div>

        {/* Additional Trade References */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-1094">
          <div className="font-semibold text-gray-900 mb-1" data-id="element-1095">
            Additional Trade References
          </div>
          <p className="text-sm text-gray-600 mb-4" data-id="element-1096">
            No additional references requested
          </p>
          <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1097">
            <Send className="w-4 h-4" data-id="element-1098" />
            REQUEST ADDITIONAL TRADE REFERENCES
          </button>
        </div>
      </div>

      {/* Personal Guarantors */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1099">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1100">
          Personal Guarantors
        </h3>
        <div className="space-y-3" data-id="element-1101">
          {/* Michael Scott - Completed */}
          <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-1102">
            {/* Collapsed Header */}
            <button onClick={() => setExpandedGuarantor(expandedGuarantor === 'michael' ? null : 'michael')} className="w-full p-4 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1103">
              <div className="flex items-center gap-4" data-id="element-1104">
                <span className="font-semibold text-gray-900" data-id="element-1105">
                  Michael Scott
                </span>
                <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-1106">
                  <div className="flex items-center gap-1" data-id="element-1107">
                    <Calendar className="w-4 h-4" data-id="element-1108" />
                    Completed on March 27, 2026
                  </div>
                  <span className="text-gray-300" data-id="element-1109">•</span>
                  <div className="flex items-center gap-1" data-id="element-1110">
                    <Mail className="w-4 h-4" data-id="element-1111" />1 email sent
                  </div>
                </div>
              </div>
              {expandedGuarantor === 'michael' ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-1112" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-1113" />}
            </button>

            {/* Expanded Content */}
            {expandedGuarantor === 'michael' && <div className="border-t border-gray-200 p-6 bg-gray-50" data-id="element-1114">
                {/* Guarantor Information */}
                <div className="mb-6" data-id="element-1115">
                  <div className="flex items-center gap-2 mb-4" data-id="element-1116">
                    <User className="w-4 h-4 text-gray-600" data-id="element-1117" />
                    <span className="font-semibold text-gray-900" data-id="element-1118">
                      Guarantor Information
                    </span>
                    <Edit2 className="w-4 h-4 text-indigo-600 cursor-pointer" data-id="element-1119" />
                  </div>
                  <div className="grid grid-cols-2 gap-6" data-id="element-1120">
                    <div data-id="element-1121">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1122">
                        Full Name
                      </label>
                      <p className="text-gray-900" data-id="element-1123">Michael Scott</p>
                    </div>
                    <div data-id="element-1124">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1125">
                        Title
                      </label>
                      <p className="text-gray-900" data-id="element-1126">Regional Manager</p>
                    </div>
                    <div data-id="element-1127">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1128">
                        Email
                      </label>
                      <p className="text-gray-900" data-id="element-1129">m.scott@dundermifflin.com</p>
                    </div>
                    <div data-id="element-1130">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1131">
                        Phone
                      </label>
                      <p className="text-gray-900" data-id="element-1132">(570) 555-0100</p>
                    </div>
                    <div data-id="element-1133">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1134">
                        Address
                      </label>
                      <p className="text-gray-900" data-id="element-1135">
                        1725 Slough Avenue, Scranton, PA 18503
                      </p>
                    </div>
                    <div data-id="element-1136">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1137">
                        SSN
                      </label>
                      <p className="text-gray-900" data-id="element-1138">***-**-4927</p>
                    </div>
                  </div>
                </div>

                {/* Guarantee Completed */}
                <div data-id="element-1139">
                  <div className="flex items-center gap-2 mb-4" data-id="element-1140">
                    <div className="font-semibold text-gray-900" data-id="element-1141">
                      Guarantee Completed
                    </div>
                    <CheckCircle className="w-5 h-5 text-green-600" data-id="element-1142" />
                  </div>
                  <p className="text-sm text-gray-600 mb-4" data-id="element-1143">
                    Personal guarantee signed on March 27, 2026
                  </p>
                  <div className="grid grid-cols-2 gap-x-12 gap-y-4 text-sm" data-id="element-1144">
                    <div className="flex justify-between" data-id="element-1145">
                      <span className="text-gray-600" data-id="element-1146">Guarantee Amount</span>
                      <span className="font-medium text-gray-900" data-id="element-1147">$50,000</span>
                    </div>
                    <div className="flex justify-between" data-id="element-1148">
                      <span className="text-gray-600" data-id="element-1149">Date Signed</span>
                      <span className="font-medium text-gray-900" data-id="element-1150">
                        March 27, 2026
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-1151">
                      <span className="text-gray-600" data-id="element-1152">Guarantee Type</span>
                      <span className="font-medium text-gray-900" data-id="element-1153">
                        Unlimited
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-1154">
                      <span className="text-gray-600" data-id="element-1155">Expiration</span>
                      <span className="font-medium text-gray-900" data-id="element-1156">None</span>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
        </div>

        {/* Additional Personal Guarantors */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-1157">
          <div className="font-semibold text-gray-900 mb-1" data-id="element-1158">
            Additional Personal Guarantors
          </div>
          <p className="text-sm text-gray-600 mb-4" data-id="element-1159">
            No additional guarantors requested
          </p>
          <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1160">
            <Send className="w-4 h-4" data-id="element-1161" />
            REQUEST ADDITIONAL PERSONAL GUARANTORS
          </button>
        </div>
      </div>

      {/* Banking Information */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1162">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1163">
          Banking Information
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1164">
          <div data-id="element-1165">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1166">
              Bank Name
            </label>
            <p className="text-gray-900" data-id="element-1167">Scranton National Bank</p>
          </div>
          <div data-id="element-1168">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1169">
              Contact
            </label>
            <p className="text-gray-900" data-id="element-1170">Robert Lipton</p>
          </div>
          <div data-id="element-1171">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1172">
              Type of Account
            </label>
            <p className="text-gray-900" data-id="element-1173">Checking</p>
          </div>
          <div data-id="element-1174">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1175">
              Account #
            </label>
            <p className="text-gray-900" data-id="element-1176">481726350</p>
          </div>
          <div data-id="element-1177">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1178">
              Email
            </label>
            <p className="text-gray-900" data-id="element-1179">r.lipton@scrantonnational.com</p>
          </div>
          <div data-id="element-1180">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1181">
              City
            </label>
            <p className="text-gray-900" data-id="element-1182">Scranton</p>
          </div>
          <div data-id="element-1183">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1184">
              State
            </label>
            <p className="text-gray-900" data-id="element-1185">PA</p>
          </div>
          <div data-id="element-1186">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1187">
              Phone #
            </label>
            <p className="text-gray-900" data-id="element-1188">570-555-0198</p>
          </div>
          <div data-id="element-1189">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1190">
              Fax #
            </label>
            <p className="text-gray-900" data-id="element-1191">570-555-0199</p>
          </div>
        </div>
      </div>

      {/* Signature */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1192">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1193">Signature</h3>

        {/* Terms & Conditions */}
        <div className="mb-6" data-id="element-1194">
          <h4 className="text-lg font-bold text-gray-900 mb-4" data-id="element-1195">
            Terms & Conditions
          </h4>
          <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg mb-4" data-id="element-1196">
            <p className="text-sm text-gray-700 leading-relaxed" data-id="element-1197">
              I understand that should my account become delinquent (terms of
              sale are based upon date of invoice) and that if the creditor
              elects to employ a third party to collect monies due, my company
              will be responsible for not only the original amount billed, but
              also all costs associated with the collection efforts including
              but not limited to reasonable attorney fees. Cash in Advance
              restrictions may be placed on any past due account. Customer will
              notify the creditor, in writing of any ownership changes or legal
              means of doing business by the company under which credit was
              established.
            </p>
          </div>
          <p className="text-sm font-semibold text-gray-900 mb-6" data-id="element-1198">
            By signing the below you give Dunder Mifflin Paper Company Inc.,
            permission to check your bank and trade references.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1199">
          <div data-id="element-1200">
            <label className="text-sm font-medium text-gray-500 mb-2 block" data-id="element-1201">
              Signature
            </label>
            <div className="border-2 border-gray-300 rounded-lg p-4 bg-white h-32 flex items-center justify-center" data-id="element-1202">
              <svg viewBox="0 0 200 60" className="w-full h-full" style={{
              maxWidth: '200px'
            }} data-id="element-1203">
                <path d="M 10 40 Q 20 20, 40 35 T 80 30 Q 100 25, 120 40 T 160 35 Q 170 30, 190 40" stroke="#1f2937" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-1204" />
              </svg>
            </div>
          </div>
          <div data-id="element-1205">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1206">
              Printed Name
            </label>
            <p className="text-gray-900" data-id="element-1207">Dwight K. Schrute</p>
          </div>
          <div data-id="element-1208">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1209">
              Title
            </label>
            <p className="text-gray-900" data-id="element-1210">Assistant Regional Manager</p>
          </div>
          <div data-id="element-1211">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1212">
              Date
            </label>
            <p className="text-gray-900" data-id="element-1213">2026-03-27</p>
          </div>
        </div>
      </div>
    </div>;
}